import {
	FilterDefinition,
	FilterKey,
	FilterRow,
	FilterSelection,
	ReportView
} from './TrainingReports.types';

export const DEFAULT_REPORT_VIEW = ReportView.Dashboard;
export const SEARCH_PLACEHOLDER = 'learning.report.searchPeople';

export const FILTER_DEFINITIONS: FilterDefinition[] = [
	{
		key: FilterKey.Assignments,
		label: 'learning.report.filterDefinitions.assignments.label',
		chipLabel: 'Asgn',
		row: FilterRow.Primary,
		multiple: true,
		icon: 'assignmentsFilterIcon'
	},
	{
		key: FilterKey.Courses,
		label: 'learning.report.filterDefinitions.courses.label',
		chipLabel: 'Course',
		row: FilterRow.Primary,
		multiple: true,
		icon: 'indiCoursesOutline'
	},
	{
		key: FilterKey.Status,
		label: 'learning.report.filterDefinitions.status.label',
		chipLabel: 'Status',
		row: FilterRow.Primary,
		multiple: false,
		options: [
			{ value: 'notStarted', label: 'learning.report.filterDefinitions.status.options.notStarted' },
			{ value: 'complete', label: 'learning.report.filterDefinitions.status.options.complete' },
			{ value: 'overdue', label: 'learning.report.filterDefinitions.status.options.overdue' }
		]
	},
	{
		key: FilterKey.CourseType,
		label: 'learning.report.filterDefinitions.courseType.label',
		chipLabel: 'Course type',
		row: FilterRow.Primary,
		multiple: false,
		options: [
			{ value: 'required', label: 'learning.report.filterDefinitions.courseType.options.required' },
			{ value: 'optional', label: 'learning.report.filterDefinitions.courseType.options.optional' }
		]
	},
	{
		key: FilterKey.Property,
		label: 'learning.report.filterDefinitions.property.label',
		chipLabel: 'Property',
		row: FilterRow.More,
		multiple: false
	},
	{
		key: FilterKey.Group,
		label: 'learning.report.filterDefinitions.group.label',
		chipLabel: 'Group',
		row: FilterRow.More,
		multiple: false
	},
	{
		key: FilterKey.Role,
		label: 'learning.report.filterDefinitions.role.label',
		chipLabel: 'Role',
		row: FilterRow.More,
		multiple: false
	},
	{
		key: FilterKey.Recertification,
		label: 'learning.report.filterDefinitions.recertification.label',
		chipLabel: 'Recertification',
		row: FilterRow.More,
		multiple: false,
		dividerBefore: true,
		options: [
			{ value: 'next30', label: 'learning.report.filterDefinitions.recertification.options.next30' },
			{ value: 'next60', label: 'learning.report.filterDefinitions.recertification.options.next60' },
			{ value: 'next90', label: 'learning.report.filterDefinitions.recertification.options.next90' },
			{ value: 'overdue', label: 'learning.report.filterDefinitions.recertification.options.overdue' }
		]
	}
];

export const FILTER_CHIP_LABELS = FILTER_DEFINITIONS.reduce(
	(labels, definition) => ({
		...labels,
		[definition.key]: definition.chipLabel
	}),
	{} as Record<FilterKey, string>
);

/**
 * The "All" row that heads every filter menu. Picking it clears that filter,
 * which is what returns the dashboard to its default state.
 */
export const ALL_OPTION_VALUE = 'all';

export const ALL_OPTION_LABELS: Partial<Record<FilterKey, string>> = {
	[FilterKey.CourseType]: 'learning.report.filterDefinitions.allCourseType'
};

export const DEFAULT_ALL_OPTION_LABEL = 'learning.report.filterDefinitions.all';

export const EMPTY_FILTER_SELECTION: FilterSelection = Object.values(
	FilterKey
).reduce((acc, key) => ({ ...acc, [key]: [] }), {} as FilterSelection);